import "../../styles/StickySocialLinks.css";
import { FaWhatsapp, FaLinkedinIn, FaFacebookF } from "react-icons/fa";

const StickySocialLinks = () => {
  return (
    <div className="sticky-social">
      <a
        href="https://wa.me/917019018677"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon whatsapp"
      >
        <FaWhatsapp />
      </a>

      <a
        href="https://www.linkedin.com/company/springevening-private-limited/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon linkedin"
      >
        <FaLinkedinIn />
      </a>

      <a
        href="https://www.facebook.com/springeveningpl"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon facebook"
      >
        <FaFacebookF />
      </a>
    </div>
  );
};

export default StickySocialLinks;
